import { render, staticRenderFns } from "./AdvertisingManager2.vue?vue&type=template&id=44421fad&scoped=true"
import script from "./AdvertisingManager2.vue?vue&type=script&lang=js"
export * from "./AdvertisingManager2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44421fad",
  null
  
)

export default component.exports